module.exports = __webpack_public_path__ + "img/warming.b817d5d9.svg";